module.exports = "<pplus-consumption-meter></pplus-consumption-meter>\r\n"